<script setup lang="ts">
import useLoadingStore from './store';
import Animation from '../animation/Animation.vue';

const { loading, message } = useLoadingStore();
</script>

<template>
  <Teleport v-if="loading" to="body">
    <div
      v-bind="$preset.loading.root"
      data-wv-name="loading-overlay"
      data-wv-section="overlay"
    >
      <Animation animation="loading-page" v-bind="$preset.loading.animation" />

      {{ message }}
    </div>
  </Teleport>
</template>

<style>
body.loading,
body.loading * {
  overflow: hidden;
}
</style>
